import { useEffect } from "react";
import { useHistory, useLocation } from "react-router-dom";
import { trackSignupPrompt } from "./client";

export const useSignupPromptTracking = () => {
  const history = useHistory();
  const location = useLocation();

  useEffect(() => {
    const { signupPrompt, ...state } = location.state || {};
    if (!signupPrompt) return;

    trackSignupPrompt(signupPrompt);
    history.replace({ ...location, state });
  }, [history, location]);
};
